import { render, staticRenderFns } from "./ButtonText.vue?vue&type=template&id=ce001ac8&scoped=true&"
import script from "./ButtonText.vue?vue&type=script&lang=js&"
export * from "./ButtonText.vue?vue&type=script&lang=js&"
import style0 from "./ButtonText.vue?vue&type=style&index=0&id=ce001ac8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce001ac8",
  null
  
)

export default component.exports